import { StyleSheet } from 'react-native';
import { green, disabledBackgroundColor } from '../../../constants/palette';

export default StyleSheet.create({
  buttonGroup: {
    marginTop: -10,
    marginBottom: -5,
  },
  followButton: {
    backgroundColor: green,
  },
  mainContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    // justifyContent: 'center',
  },
  restartButton: {
    marginTop: 5,
  },
  playButton: {
    flexDirection: 'row',
    paddingLeft: 20,
    paddingRight: 20,
  },
  skipButton: {},
});
